module.exports = "pegasus_template/assets/theme3/theme3_theme.png";